import { getId, supportsDateBucketizationChange, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getChartType, getVisibleSeriesIds, getXAxisColumns, getYAxisColumnById, getYAxisColumns, isSeriesPresentInVisibleSeries, isXAxisMeasure, } from '../core/chart-model-utils';
import * as chartTypeSpecificationService from '../core/chart-type-specification-service';
import { getConditionalFormats } from '../core/conditional-formatting-utils';
import { mapArrayToBooleanHash } from '../utils';
import { validateCfCondition } from './blink-highchart-config-util';
function isColumnFromDateFamily(axisColumn) {
    if (!axisColumn) {
        return false;
    }
    return supportsDateBucketizationChange(axisColumn);
}
export function applyConditionalFormattingStyle(serie, series) {
    serie.data.forEach((dataRow, index) => {
        var _a, _b, _c, _d, _e, _f;
        if (!((_a = serie.xConditionalFormattings) === null || _a === void 0 ? void 0 : _a.length) &&
            !((_b = serie.yConditionalFormattings) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        if ((_c = serie.xConditionalFormattings) === null || _c === void 0 ? void 0 : _c.length) {
            const applicableFormatting = _.find(serie.xConditionalFormattings, conditionalMetric => {
                return validateCfCondition(conditionalMetric, series, index, 'x', dataRow, serie === null || serie === void 0 ? void 0 : serie.inScopeParameters);
            });
            const color = !(applicableFormatting === null || applicableFormatting === void 0 ? void 0 : applicableFormatting.plotAsBand) &&
                ((_d = applicableFormatting === null || applicableFormatting === void 0 ? void 0 : applicableFormatting.solidBackgroundAttrs) === null || _d === void 0 ? void 0 : _d.color);
            if (color) {
                dataRow.color = color;
            }
        }
        if ((_e = serie.yConditionalFormattings) === null || _e === void 0 ? void 0 : _e.length) {
            const applicableFormatting = _.find(serie.yConditionalFormattings, conditionalMetric => {
                return validateCfCondition(conditionalMetric, series, index, 'y', dataRow, serie === null || serie === void 0 ? void 0 : serie.inScopeParameters);
            });
            const color = !(applicableFormatting === null || applicableFormatting === void 0 ? void 0 : applicableFormatting.plotAsBand) &&
                ((_f = applicableFormatting === null || applicableFormatting === void 0 ? void 0 : applicableFormatting.solidBackgroundAttrs) === null || _f === void 0 ? void 0 : _f.color);
            if (color) {
                dataRow.color = color;
            }
        }
    });
}
export function configureConditionalFormatting(chartModel, chartConfig) {
    const allowedConfigurations = chartTypeSpecificationService.configOptions(getChartType(chartModel), chartModel).allowedConfigurations;
    const shouldShowBackgroundColor = allowedConfigurations.conditionalFormatEditorParams
        .isBackgroundColorPickerAvailable;
    if (allowedConfigurations.conditionalFormatting &&
        shouldShowBackgroundColor) {
        const xAxisColumns = getXAxisColumns(chartModel);
        const xAxisColumn = isXAxisMeasure(chartModel) ? xAxisColumns[0] : '';
        const yAxisColumns = getYAxisColumns(chartModel) || [];
        const xConditionalFormattings = xAxisColumn &&
            !isColumnFromDateFamily(xAxisColumn) &&
            getConditionalFormats(chartModel.vizProp, getId(xAxisColumn), 'ChartVizProps', chartModel);
        chartConfig.series.forEach(serie => {
            const yAxisColumn = getYAxisColumnById(chartModel, serie.blinkSeriesId) ||
                yAxisColumns[0];
            const yConditionalFormattings = yAxisColumn &&
                !isColumnFromDateFamily(yAxisColumn) &&
                getConditionalFormats(chartModel.vizProp, getId(yAxisColumn), 'ChartVizProps', chartModel);
            serie.xConditionalFormattings = xConditionalFormattings;
            serie.yConditionalFormattings = yConditionalFormattings;
            serie.inScopeParameters = chartModel === null || chartModel === void 0 ? void 0 : chartModel.inScopeParameters;
            applyConditionalFormattingStyle(serie, chartConfig.series);
        });
    }
}
export function getXRawValuesFromSerie(serie, ignoreNullOrUndefined, shouldFlatten) {
    let xRawValues = serie.userOptions.data.map(data => { var _a; return (_a = data.xRawValues) === null || _a === void 0 ? void 0 : _a.map(xRawValue => xRawValue); });
    if (ignoreNullOrUndefined) {
        xRawValues = xRawValues
            .map(xRawValueArray => _.without(xRawValueArray, null, undefined))
            .filter(xRawValueArray => xRawValueArray.length > 0);
    }
    if (shouldFlatten)
        return _.flatten(xRawValues);
    return xRawValues;
}
export function configureSeriesVisibility(chartModel, dataModel, series) {
    let visibleSeriesIds = getVisibleSeriesIds(chartModel);
    let visibleSeriesIdMap = null;
    if (!isSeriesPresentInVisibleSeries(chartModel, dataModel)) {
        visibleSeriesIds = [];
    }
    else if (!_.isEmpty(visibleSeriesIds)) {
        visibleSeriesIds = visibleSeriesIds.map(id => id.toLowerCase());
        visibleSeriesIdMap = mapArrayToBooleanHash(visibleSeriesIds);
    }
    return series.map(chartSerie => {
        if (visibleSeriesIdMap)
            chartSerie.visible =
                _.has(visibleSeriesIdMap, chartSerie.blinkSeriesId.toLowerCase()) || _.has(visibleSeriesIdMap, chartSerie.name.toLowerCase());
        else
            chartSerie.visible = true;
        return chartSerie;
    });
}
//# sourceMappingURL=highchart-series-util.js.map